import React, { useEffect, useState, useContext } from "react";
import { utils, writeFile } from "xlsx";
import { BACKEND_API } from "../../../constants/backendApi";

//Style
import "./CancellationBody.css";

//Components
import CreditDetailsTableComponent from "../../CreditDetailsTableComponent/CreditDetailsTableComponent";

//Context
import { LoadingContext } from "../../../context/LoadingContext";

//hooks
import useDebounce from "../../../hooks/useDebounce";

const CancellationBody = ({ userData }) => {
  const { setLoading } = useContext(LoadingContext);

  const [maxData, setMaxData] = useState(10);

  const [initPage, setInitPage] = useState(0);

  const [creditList, setCreditList] = useState([]);

  const [creditListExcel, setCreditListExcel] = useState([]);

  const [totalCredits, setTotalCredits] = useState(0);

  const [years, setYears] = useState([]);

  const [, setTotalCurrentLoans] = useState(0);

  const [filterData, setFilterData] = useState({
    type: "",
    document_plate: "",
    advisor: "",
    insurer: "",
    credit_state: "",
    next_to_renew: "",
    year: new Date().getFullYear(),
  });

  const tableFields = [
    {
      name: "Altura",
    },
    {
      name: "Nombre Cliente",
    },
    {
      name: "Vigencia Inicial",
    },
    {
      name: "No. de Documento",
    },
    {
      name: "Placa/Detalle de Riesgo",
    },
    {
      name: "No. de Poliza",
    },
  ];

  const token = localStorage.getItem("token");

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearOptions = [];

    for (let year = 2020; year <= currentYear; year++) {
      yearOptions.push(
        <option key={year} value={year}>
          {year}
        </option>
      );
    }

    setYears(yearOptions);

    try {
      const selectInsurer = document.getElementById("insurer");

      fetch(`${BACKEND_API}/api/insurance-companies`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then(({ data }) => {
          data.map((insurer) => {
            const option = document.createElement("option");
            option.text = insurer.NombreAseguradora;
            option.value = insurer.IdAseguradora;
            selectInsurer?.appendChild(option);

            const optionsArray = Array.from(selectInsurer?.options ?? []);

            return optionsArray.sort((a, b) => a.text.localeCompare(b.text));
          });
        });
    } catch (err) {
      console.log(err);
    }

    const filterBody = {
      userDocument: filterData.document_plate,
      anio: filterData.year,
      paginado: "999999",
      offset: "0",
    };

    try {
      fetch(`${BACKEND_API}/api/credit-canceled-all`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(filterBody),
      })
        .then((res) => res.json())
        .then(({ data }) => {
          if (data?.listaCreditosRet) {
            setCreditListExcel(data.listaCreditosRet);
          } else {
            setCreditList([]);
            setTotalCredits(0);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (err) {
      console.log(err);
    }
  }, [
    filterData?.document_plate,
    filterData?.year,
    filterData?.insurer,
    initPage,
    maxData,
    setLoading,
    token,
  ]);

  const debouncedSearch = useDebounce((filterData) => {
    setLoading(true);

    const filterBody = {
      userDocument: filterData.document_plate,
      anio: String(filterData.year),
      paginado: String(maxData),
      offset: String(initPage),
    };

    try {
      fetch(`${BACKEND_API}/api/credit-canceled-all`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(filterBody),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.message === "informacion creditos anulados") {
            const creditsNewArr = data.data.listaCreditosRet.map((credit) => [
              {
                field_content: credit.altura + " de " + credit.altura,
              },
              {
                field_content: credit.NombreCliente,
              },
              {
                field_content: credit.vigInicial,
              },
              {
                field_content: credit.noDoc,
              },
              {
                field_content: credit.riesgo,
              },
              {
                field_content: credit.poliza,
              },
            ]);
            setTotalCredits(data.data.cantRegistros);
            setCreditList(creditsNewArr);
          } else {
            setCreditList([]);
            setTotalCredits(0);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (err) {
      console.log(err);
    }
  }, 500);

  useEffect(() => {
    debouncedSearch(filterData);
    // eslint-disable-next-line
  }, [maxData, initPage, filterData]);

  const getMaxDataValue = (maxDataVal) => {
    setMaxData(maxDataVal);
  };

  const getPaginationData = (initPageVal) => {
    setInitPage(initPageVal);
  };

  const handleGetFilters = (e) => {
    if (e.target.name === "document_plate") {
      setFilterData({
        ...filterData,
        type: e.target.value !== "" ? "Documento_Placa" : "",
        [e.target.name]: e.target.value,
      });
    }

    if (
      e.target.name === "advisor" ||
      e.target.name === "insurer" ||
      e.target.name === "credit_state"
    ) {
      setFilterData({
        ...filterData,
        type: "FiltrosVarios",
        [e.target.name]: e.target.value,
      });
    }

    setFilterData({
      ...filterData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCleanFilters = () => {
    setFilterData({
      type: "",
      document_plate: "",
      advisor: "",
      insurer: "",
      credit_state: "",
      next_to_renew: "",
      year: new Date().getFullYear(),
    });
  };

  const exportToExcel = () => {
    const jsonData = creditListExcel.map((credit) => {
      return {
        Altura: credit.altura + " de " + credit.altura,
        NombreCliente: credit.NombreCliente,
        NoDocumento: credit.noDoc,
        PlacaDetalleRiesgo: credit.riesgo,
        NoPoliza: credit.poliza,
        VigenciaInicial: credit.vigInicial,
      };
    });

    const workbook = utils.book_new();

    const worksheet = utils.json_to_sheet(jsonData);

    utils.book_append_sheet(workbook, worksheet, "Creditos en anulacion");

    writeFile(workbook, "Creditos en anulación.xlsx");
  };

  return (
    <section className="cancellation-section">
      <div className="cancellation-subcontainer">
        <div className="c-title-container">
          <h1 className="c-title">Créditos Anulados</h1>
        </div>
        <div className="c-description-txt-container">
          <p className="cdt-txt">
            Créditos que no finalizaron el proceso de creación, porque les hizo
            falta alguno de los dos requisitos.
          </p>
        </div>
        <div className="filter-elms-container">
          <div className="input-container">
            <form onChange={handleGetFilters} className="filter-form-container">
              <label>
                <h1 className="label-title">Número de Documento o Placa:</h1>
                <input
                  className="filter-input-search"
                  type="text"
                  placeholder="Numero de Documento o Placa"
                  title="Numero de Documento o Placa"
                  name="document_plate"
                  value={filterData.document_plate}
                />
              </label>
              {userData?.profile !== "Aseguradora" && (
                <label>
                  <h1 className="label-title">Aseguradora:</h1>
                  <select
                    name="insurer"
                    id="insurer"
                    disabled={filterData.document_plate !== "" ? true : false}
                    value={filterData.insurer}
                  >
                    <option value="">--Seleccione--</option>
                  </select>
                </label>
              )}
              <label>
                <h1 className="label-title">Año:</h1>
                <select name="year" id="year" value={filterData.year}>
                  <option value="">--Seleccione--</option>
                  {years}
                </select>
              </label>
            </form>
            <button
              className="c-btn-search"
              title="Limpiar Filtros"
              onClick={handleCleanFilters}
            >
              Limpiar Filtros
            </button>
          </div>
        </div>
        <div
          className="cip-download-excel-container"
          style={{ display: creditList.length > 0 ? "unset" : "none" }}
        >
          <button
            title="Descargar Excel"
            className="cip-de-btn"
            onClick={() => exportToExcel()}
          >
            Descargar Excel
          </button>
        </div>
        <div className="credit-details-table-supercontainer">
          <CreditDetailsTableComponent
            getMaxData={getMaxDataValue}
            maxData={maxData}
            getPaginationInit={getPaginationData}
            credits={creditList}
            totalCreditsNum={totalCredits}
            filterData={filterData}
            fields={tableFields}
          />
        </div>
      </div>
    </section>
  );
};

export default CancellationBody;
